<template>
    <div class="orderDetails">
        <div class="detailsView">
            <div class="header">
                <!--手动关闭的时候，才展示-->
                <a href="tel: 400-066-5298" v-if="orderInfo.finishWay !== 'NORMAL'">
                    <img src="../../../assets/images/ic_bill_service.png" class="service" alt="">
                </a>
                <p class="storeName">{{orderInfo.storeName}}</p>
                <p class="useTime" v-if="orderInfo.status === 'USING'">{{usingTimeFormat(orderInfo.usingTime)}}</p>
                <p class="useTime" v-else>+ {{orderInfo.earnings}}</p>
                <div class="orderStatus" :class="getStatusClass(orderInfo.status)">
                    <span>{{statusObject[orderInfo.status]}}</span>
                </div>
                <img class="userIcon" :src="orderInfo.avatar" alt="">
                <div class="userInfo">
                    <span>{{orderInfo.nickName}} {{orderInfo.mobile}}</span>
                    <img class="payTypeIcon" v-if="orderInfo.channel === 'WX'"
                         src="../../../assets/images/ic_wechat.png" alt="">
                    <img class="payTypeIcon" v-else src="../../../assets/images/ic_alipay.png" alt="">
                </div>
            </div>
            <div class="rowView">
                <div class="row" v-if="!isStore">
                    <div class="TitleCol">订单金额</div>
                    <div class="valueCol orderMoney">{{orderInfo.money}}元</div>
                </div>
                <div class="row">
                    <div class="TitleCol">订单编号</div>
                    <div class="valueCol">{{orderInfo.sn}}</div>
                </div>
                <div class="row" v-if="orderInfo.deviceType.value !== 'CHARGER'">
                    <div class="TitleCol">计息单价</div>
                    <div class="valueCol">
                        {{orderInfo.price}}元/{{deviceMoneyCalTypeObject[orderInfo.deviceMoneyCalType]}}，{{orderInfo.dayMax}}元/一天(封顶)
                    </div>
                </div>
                <div class="row">
                    <div class="TitleCol">开始时间</div>
                    <div class="valueCol">{{orderInfo.rentDate}}</div>
                </div>
                <div class="row" v-if="!isStore">
                    <div class="TitleCol">结束时间</div>
                    <div class="valueCol">{{orderInfo.backDate}}</div>
                </div>
                <div class="row" v-else>
                    <div class="TitleCol">结束时间</div>
                    <div class="valueCol">{{orderInfo.dayPartingBackDate ? orderInfo.dayPartingBackDate : orderInfo.backDate}}</div>
                </div>
                <div class="row">
                    <div class="TitleCol">优惠券</div>
                    <div class="valueCol">-0.00元</div>
                </div>
            </div>
        </div>
        <!--
               以下内容只有代理才能看到
        -->
        <template v-if="!isStore">
            <div class="detailsView borrow">
                <div class="rowView">
                    <div class="row">
                        <div class="TitleCol">网点类型</div>
                        <div class="valueCol orderMoney">{{orderInfo.siteTypeName}}</div>
                    </div>
                    <div class="row">
                        <div class="TitleCol">网点名称</div>
                        <div class="valueCol">{{orderInfo.storeName}}</div>
                    </div>
                    <div class="row">
                        <div class="TitleCol">底座SN</div>
                        <div class="valueCol">{{orderInfo.deviceSn}}</div>
                    </div>
                    <div class="row">
                        <div class="TitleCol">网点地址</div>
                        <div class="valueCol">{{orderInfo.address}}</div>
                    </div>
                    <!--
                        如果该订单是线，则不显示充电宝SN和弹出槽位
                    -->
                    <template v-if="orderInfo.deviceType.value !== 'CHARGER'">
                        <div class="row">
                            <div class="TitleCol">充电宝SN</div>
                            <div class="valueCol">{{orderInfo.bankSn}}</div>
                        </div>
                        <div class="row">
                            <div class="TitleCol">弹出槽位</div>
                            <div class="valueCol">{{orderInfo.rentSlotNo}}号</div>
                        </div>
                    </template>
                </div>
            </div>
            <!--
                如果该订单是线，则无归还信息，原因：线不能还到别的地方去
                以下状态才展示归还信息：
                                            POWER_BANK： 是宝
                                            NORMAL： 订单是正常结束，非手动结束
                                            BOUGHT：不是已购买的订单
                                            OVERTIME_AND_PAYMENT：不是逾期订单
            -->
            <template v-if="orderInfo.deviceType.value !== 'CHARGER' && orderInfo.status !== 'BOUGHT' && orderInfo.status !== 'OVERTIME_AND_PAYMENT'">
                <div class="detailsView return">
                    <div class="rowView">
                        <div class="row">
                            <div class="TitleCol">网点类型</div>
                            <div class="valueCol orderMoney">{{orderInfo.backSiteTypeName}}</div>
                        </div>
                        <div class="row">
                            <div class="TitleCol">网点名称</div>
                            <div class="valueCol">{{orderInfo.backStoreName}}</div>
                        </div>
                        <div class="row">
                            <div class="TitleCol">底座SN</div>
                            <div class="valueCol">{{orderInfo.backDeviceSn}}</div>
                        </div>
                        <div class="row">
                            <div class="TitleCol">网点地址</div>
                            <div class="valueCol">{{orderInfo.backStoreAddress}}</div>
                        </div>
                        <div class="row">
                            <div class="TitleCol">充电宝SN</div>
                            <div class="valueCol">{{orderInfo.bankSn}}</div>
                        </div>
                        <div class="row">
                            <div class="TitleCol">弹出槽位</div>
                            <div class="valueCol">{{orderInfo.backSlotNo}}号</div>
                        </div>
                    </div>
                </div>
            </template>
            <div class="detailsView" v-if="profitList.length > 0">
                <div class="rowView">
                    <div class="row" v-for="(item, index) in  profitList" :key="index">
                        <div class="TitleCol">
                            {{item.deviceAgent ? '(座)' : ''}}
                            {{item.powerBankAgent ? '(宝)' : ""}}
                            {{item.level.levelCode === 'F' ? '(商家)' : ''}}
                            {{item.agentName}}
                        </div>
                        <div class="valueCol">¥ {{item.agentMoney}}</div>
                    </div>
                </div>
            </div>
            <Button v-if="orderInfo.status === 'USING'" class="closeOrderBtn" @click="showCloseOrder">结束订单</Button>
            <Popup v-model="showPopup" class='closeOrderPopup' closeable>
                <div class="popupView">
                    <h2 class="popupTitle">结束订单</h2>
                    <div class="">
                        <div class="popupItem van-hairline--bottom">
                            <span class="title">操作类型</span>
                            <input type="text" v-model="closeOrderForm.typeText" @click="showCloseOrderPopup = true"
                                   readonly placeholder="请选择类型"/>
                            <Icon name="arrow"/>
                        </div>
                        <div class="popupItem van-hairline--bottom" v-if="closeOrderForm.type === 'ASSIGN_MONEY'">
                            <span class="title">指定金额</span>
                            <input type="text" class="marign" v-model="closeOrderForm.money" placeholder="请输入金额"/>
                        </div>
                        <div class="popupItem van-hairline--bottom">
                            <span class="title">备注</span>
                            <input type="text" v-model="closeOrderForm.description" class="marign" placeholder="请输入备注"/>
                        </div>
                    </div>
                    <Button class="closeOrderBtn" @click="closeOrder">确定</Button>
                </div>
            </Popup>
            <!--结束订单类型选择弹窗-->
            <Popup v-model="showCloseOrderPopup" position="bottom">
                <Picker
                    show-toolbar
                    :columns="closeOrderTypeList"
                    @confirm="onConfirmCloseType"
                    @cancel="showCloseOrderPopup = false"/>
            </Popup>
        </template>
    </div>
</template>

<script>
    /*
    * 订单详情
    * */
    import {getOrderDetail} from '../../../api/order';
    import {Button, Popup, Picker, Icon} from 'vant';
    import {closeOrderApi, getProfitList} from "../../../api/order";
    import {mapState} from 'vuex';

    export default {
        name: "OrderDetails",
        components: {
            Button,
            Popup,
            Picker,
            Icon
        },
        data() {
            return {
                showCloseOrderPopup: false,
                showPopup: false,
                orderSn: '',
                orderInfo: {
                    deviceType: {}
                },
                statusObject: {
                    'PENDING_PAYMENT': '待支付',
                    'PAYMENT_COMPLETED': '待出宝',
                    'USING': '使用中',
                    'DONE': '已完成',
                    'WAITING_PAID': '待扣款',
                    'REFUNDED': '已退款',
                    'BOUGHT': '已购买',
                    'OVERTIME_AND_PAYMENT': '逾期并已结算',
                },
                deviceMoneyCalTypeObject: {
                    'HALF_HOUR': '半小时',
                    'ONE_HOUR': '小时',
                },
                closeOrderTypeList: [
                    {
                        text: '扣除至当前时间的租金',
                        value: 'DEPOSIT_NOW'
                    }, {
                        text: '扣除押金',
                        value: 'DEPOSIT_ALL',
                    }, {
                        text: '扣除指定金额',
                        value: 'ASSIGN_MONEY'
                    }
                ],
                closeOrderForm: {
                    description: '',
                    money: '',
                    type: 'DEPOSIT_NOW',
                    typeText: '扣除至当前时间的租金'
                },
                profitList: []
            }
        },
        computed: {
            ...mapState(['isStore'])
        },
        created() {
            this.orderSn = this.$route.query.orderSn;
            this.getDetail();
            getProfitList(this.orderSn).then(res => {
                console.log(res);
                this.profitList = res;
            })
        },
        methods: {
            getDetail() {
                getOrderDetail(this.orderSn).then(res => {
                    this.orderInfo = res;
                })
            },
            // 确认选择结束订单类型
            onConfirmCloseType(obj) {
                this.closeOrderForm.type = obj.value;
                this.closeOrderForm.typeText = obj.text;
                this.closeOrderForm.money = '';
                this.showCloseOrderPopup = false;
            },
            // 关闭订单
            closeOrder() {
                if (this.closeOrderForm.type === 'ASSIGN_MONEY' && (this.closeOrderForm.money === '' || this.closeOrderForm.money === ' ')) {
                    return this.toast({
                        text: '请填写指定金额',
                        icon: 'warning'
                    })
                }
                closeOrderApi(this.closeOrderForm).then(res => {
                    this.getDetail();
                })
            },
            showCloseOrder() {
                this.closeOrderForm = {
                    orderSn: this.orderSn,
                    description: '',
                    money: '',
                    type: 'DEPOSIT_NOW',
                    typeText: '扣除至当前时间的租金'
                };
                this.showPopup = true;
            },
            getStatusClass(status) {
                if (status === 'DONE' || status === 'REFUNDED') {
                    return 'cc2c2c2'
                }
            },
            usingTimeFormat(usingTime) {
                if (usingTime === '0') {
                    return usingTime + '分钟';
                }
                let day = parseInt(usingTime / 60 / 24);
                let hour = parseInt(usingTime / 60 % 24);
                let min = parseInt(usingTime % 60);
                let StatusMinute = "";
                if (day > 0) {
                    StatusMinute = day + "天";
                }
                if (hour > 0) {
                    StatusMinute += hour + "小时";
                }
                if (min > 0) {
                    StatusMinute += parseFloat(min) + "分钟";
                }
                return StatusMinute;
            }
        }
    }
</script>

<style lang='less' scoped>
    .orderDetails {
        min-height: 100vh;
        padding-top: 2.8vw;
        box-sizing: border-box;
        background-color: #f8f8f8;

        .detailsView {
            width: 93.9vw;
            margin: 0 auto 2.67vw;
            background-color: #ffffff;
            box-shadow: 0 0.5vw 1.3vw -0.5vw rgba(0, 0, 0, 0.08);
            border-radius: 2.7vw;

            &.borrow {
                background: #fff url("../../../assets/images/ic_order_bg.png") center center no-repeat;
                background-size: 24vw 26.93vw;
            }

            &.return {
                background: #fff url("../../../assets/images/ic_order_bg2.png") center center no-repeat;
                background-size: 24vw 26.93vw;
            }

            .header {
                position: relative;
                text-align: center;

                .service {
                    position: absolute;
                    right: 3vw;
                    top: 3vw;
                    width: 5.87vw;
                    height: 5.87vw;
                }
                .storeName {
                    line-height: 13.9vw;
                    font-size: 4vw;
                    color: #108ee9;
                }

                .useTime {
                    margin-bottom: 2.8vw;
                    font-size: 7.5vw;
                    line-height: 7.5vw;
                    color: #108ee9;
                }

                .orderStatus {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    max-width: 22vw;
                    height: 4.4vw;
                    margin: 0 auto 5.2vw;
                    border: solid 1px #fe8f51;
                    font-size: 3.2vw;
                    color: #fe8f51;
                    -webkit-box-sizing: border-box;
                    -moz-box-sizing: border-box;
                    box-sizing: border-box;

                    &.cc2c2c2 {
                        color: #b9b9b9;
                        border-color: #b9b9b9;
                    }
                }

                .userIcon {
                    width: 9.3vw;
                    height: 9.3vw;
                    margin-bottom: 3.2vw;
                    border-radius: 50%;
                }

                .userInfo {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    height: 5.3vw;
                    font-size: 3.7vw;
                    color: #333333;

                    .payTypeIcon {
                        width: 4.4vw;
                        height: 4.4vw;
                        margin-left: 1.6vw;
                    }
                }
            }

            .rowView {
                padding: 5vw 6.3vw 3vw 6.8vw;

                .row {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    height: 7.5vw;
                    font-size: 3.2vw;

                    .TitleCol {
                        color: #999999;
                    }

                    .valueCol {
                        color: #333333;

                        &.orderMoney {
                            color: #108ee9;
                        }
                    }
                }
            }
        }

        .closeOrderBtn {
            display: block;
            width: 78.8vw;
            height: 11.33vw;
            margin: 6.13vw auto;
            border: none;
            line-height: 11.33vw;
            background-color: #43a2fe;
            border-radius: 5.67vw;
            font-size: 4vw;
            color: #ffffff;
        }

        .closeOrderPopup {
            border-radius: 2.67vw;

            .popupView {
                width: 77.73vw;
                padding: 0 5.5vw;

                .popupTitle {
                    line-height: 15vw;
                    text-align: center;
                    font-size: 4vw;
                    font-weight: bold;
                    color: #333333;
                }

                .popupItem {
                    display: flex;
                    align-items: center;
                    height: 10.8vw;
                    color: #d2d2d2;
                    font-size: 3.73vw;

                    .title {
                        color: #333333;
                    }

                    input {
                        flex: 1;
                        margin-right: 3.07vw;
                        outline: none;
                        border: none;
                        text-align: right;
                        color: #333;

                        &.marign {
                            margin-right: 6.3vw;
                        }

                        &::placeholder {
                            color: #c7c7c7;
                        }
                    }
                }

                .closeOrderBtn {
                    display: block;
                    width: 23.6vw;
                    height: 8vw;
                    border: none;
                    margin: 5.47vw auto 4.67vw;
                    line-height: 8vw;
                    background-color: #43a2fe;
                    border-radius: 1.6vw;
                    font-size: 3.2vw;
                    color: #ffffff;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/page/mine/order/Details.vue